import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { RequestModuleEnum } from '../../../shared/enums/request-module-enum';
import { TEMPLATE_LIST_ALL_PATH } from '../api';
import { SmsTemplateListAllInterface } from '../types';
export function useSmsTemplatesListAll(shouldFetch) {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (!user) {
        return null;
      }
      return [TEMPLATE_LIST_ALL_PATH, RequestModuleEnum.SmsTemplates];
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate
  } = useControlledSwr(t1, fetcher, undefined, shouldFetch);
  let t2;
  if ($[3] !== data || $[4] !== mutate) {
    t2 = {
      data,
      mutate
    };
    $[3] = data;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}